// Types
import type {
  IImportErrorFormatter,
  TImportFormattedError,
  TImportRequestErrors,
} from '~/shared/import/types';

export class ImportRequestErrorFormatter implements IImportErrorFormatter {
  public process(errors: TImportRequestErrors): TImportFormattedError[] {
    const errorMap: Record<string, TImportFormattedError> = {};

    Object.entries(errors).forEach(([key, messages]) => {
      const rowNumber: number | null = this.extractRowNumber(key);
      const fieldName: string = this.extractFieldName(key);
      const title: string = `Row ${rowNumber}`;

      if (!errorMap[title]) {
        errorMap[title] = {
          title,
          items: [],
        };
      }

      errorMap[title].items.push(...messages.map((message) => `${fieldName}: ${message}`));
    });

    return Object.values(errorMap);
  }

  protected extractRowNumber(key: string): number | null {
    const match = key.match(/rows\.(\d+)/);

    return match ? parseInt(match[1], 10) : null;
  }

  protected extractFieldName(key: string): string {
    const match = key.match(/rows\.\d+\.(.+)/);

    return match ? match[1] : 'Unknown field';
  }
}
